module.exports = __webpack_public_path__ + "static/media/hubspotlogo-web-black.91d6746c.svg";